class IndicativeNumberModel {

    constructor(id, number) {
        this.id = id;
        this.number = number;
    }

}

export default IndicativeNumberModel